import { ORDER_DETAIL, ORDER_LIST ,ITEM_DETAIL ,GET_ITEM, CHECK_UPDATE } from './orderTypes'
import { Order } from '../../models/order/order'

export default {
    [ORDER_LIST](state, data) {
        state.orderData = data;
        let order_arr = [];
        for(let i = 0; i < data.items.length; i++) {
            order_arr.push(new Order(data.items[i]));
        }
        state.orderList = order_arr;
    },

    [ORDER_DETAIL](state, data) {
        state.orderDetail = new Order(data);
    },

    [ITEM_DETAIL](state , data){
        state.itemDetail = data;
    },

    [GET_ITEM](state, data){
        state.itemData = data;
    },

    [CHECK_UPDATE](state, data) {
        state.lastOrderRecord = data;
    }
}
